import React from 'react';
import { numberLabel } from '../../services/ranks';

// Position, clinical rank and on-call grade. The position is picked from the
// department's list (Ranks & Positions) and is display only; picking one fills
// in its SUGGESTED rank and grade, which stay editable here -- the solver reads
// only these two numbers (Oct 2026). Shared by the Add Staff form and the staff
// drawer so they cannot drift.

const box = 'w-full h-[44px] px-4 bg-white border border-slate-200 rounded-xl text-sm font-bold text-slate-700 outline-none focus:ring-2 focus:ring-[var(--primary)]/20 focus:border-[var(--primary)]';
const label = 'text-[10px] font-bold text-slate-400 uppercase tracking-[0.15em] ml-1';

export default function RankGradeFields({ position, setPosition, positions = [], rank, setRank, grade, setGrade,
                                          rankLabels = {}, gradeLabels = {} }) {
  const pick = (key) => {
    setPosition(key);
    const p = positions.find(x => x.key === key);
    if (p) {                      // suggestions only: still editable below
      setRank(p.rank);
      setGrade(p.oncallGrade);
    }
  };
  const known = !position || positions.some(p => p.key === position);
  return (
    <>
      <div className="flex flex-col gap-1.5">
        <label className={label}>Position</label>
        <select aria-label="Position" value={position} onChange={(e) => pick(e.target.value)} className={`${box} cursor-pointer`}>
          <option value="">No position</option>
          {!known && <option value={position}>{position} (removed)</option>}
          {positions.map(p => <option key={p.key} value={p.key}>{p.label}</option>)}
        </select>
        {positions.length === 0 && (
          <p className="text-[10px] text-slate-400 ml-1">Positions are set up in Ranks &amp; Positions.</p>
        )}
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div className="flex flex-col gap-1.5">
          <label className={label}>Rank</label>
          <select aria-label="Rank" value={rank} onChange={(e) => setRank(Number(e.target.value))} className={`${box} cursor-pointer`}>
            {[0, 1, 2, 3, 4].map(r => <option key={r} value={r}>{numberLabel(r, rankLabels)}</option>)}
          </select>
        </div>
        <div className="flex flex-col gap-1.5">
          <label className={label}>On-call grade</label>
          <select aria-label="On-call grade" value={grade === null ? '' : grade}
            onChange={(e) => setGrade(e.target.value === '' ? null : Number(e.target.value))} className={`${box} cursor-pointer`}>
            <option value="">No on-call</option>
            {[0, 1, 2].map(g => <option key={g} value={g}>{numberLabel(g, gradeLabels)}</option>)}
          </select>
        </div>
      </div>
    </>
  );
}
